export const STEM_ICONS = {
  instrumental: (
    <>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M7 5v10M11 5v10M15 5v10M19 5v10M5 15h14" />
    </>
  ),
  vocals: (
    <>
      <rect x="9" y="3" width="6" height="11" rx="3" />
      <path d="M5.5 11.5a6.5 6.5 0 0 0 13 0M12 18v3M8.5 21h7" />
    </>
  ),
  drums: (
    <>
      <ellipse cx="12" cy="8" rx="8" ry="3" />
      <path d="M4 8v8c0 1.7 3.6 3 8 3s8-1.3 8-3V8M8 10v7M16 10v7M7 4l9-2M15 2l2 4" />
    </>
  ),
  bass: (
    <path d="M9 18c-2.7 2.7-6.8-.5-4.3-3.4 1-1.2 2.4-1.5 3.5-1.2l6.6-8.2 2.8 2.3-6.7 8.1c.4.9.1 1.8-.9 2.8zM16 4l3-1 2 2-1 3M9 13l3 2" />
  ),
  guitar: (
    <path d="M9.2 18.8c-2.6 2.6-7 .2-4.5-3.2 1.2-1.6 3-1.8 4.2-1.2l5.8-7 2.7 2.3-5.8 7c.4.9 0 1.6-.8 2.4zM16 8l3-5M18 4l2 2M8 14l3 3" />
  ),
  piano: (
    <>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M7 5v14M11 5v14M15 5v14M19 5v14M5 14h14" />
    </>
  ),
  other: <path d="M3 12h2M7 8v8M11 5v14M15 7v10M19 10v4M23 12h-2" />,
};

export const ICON_TONES = {
  blue: "bg-[#EEF1FF] text-blue-600",
  pink: "bg-[#FFEAF4] text-[#B01861]",
  teal: "bg-[#DFFFFC] text-[#08736C]",
  orange: "bg-[#FFF0DF] text-[#8B3F05]",
};
